export var config = {
  background: '#fff',
  foreground: '#000',
  selection: '#0064ff26',
  selectionMatch: '#0064ff4c',
  cursor: '#004bff',
  dropdownBackground: '#f4f6fc',
  dropdownBorder: '#e7ecf2',
  activeLine: '#0064ff0c',
  matchingBracket: '#0064ff4c',
  keyword: null,
  storage: null,
  variable: null,
  parameter: null,
  function: null,
  string: '#6b7a88',
  constant: null,
  type: null,
  class: null,
  number: null,
  comment: '#bec9d3',
  heading: null,
  invalid: null,
  regexp: '#6b7a88',
  tag: null
};